export default __webpack_public_path__ + "static/media/action-tick-unchecked.585be016.svg";